// extracted by mini-css-extract-plugin
export default {"image":"intro_image__3SZm3","right":"intro_right__7gHXi","left":"intro_left__O53uS","section":"intro_section__vsqMy"};